import styles from "./LandingFooter.module.scss";
import logo from "../../assets/wattlord-logo.svg";
import telegram from "@assets/redesign/social/telegram.svg";
import facebook from "@assets/redesign/social/facebook.svg";
import linkedin from "@assets/redesign/social/linkedin.svg";
import x from "@assets/redesign/social/x.svg";
import medium from "../../assets/social-medium.svg";
import instagram from "../../assets/social-instagram.svg";
import { useIntl } from "react-intl";

function LandingFooter() {
  const { formatMessage } = useIntl();
  const links = [
    formatMessage({ id: "wlp.footer.terms" }),
    formatMessage({ id: "wlp.footer.privacy" }),
    formatMessage({ id: "wlp.footer.cookie" }),
    formatMessage({ id: "wlp.footer.refund" }),
    formatMessage({ id: "wlp.footer.acceptable" }),
    formatMessage({ id: "wlp.footer.disclaimer" }),
    formatMessage({ id: "wlp.footer.contact" }),
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <img src={logo} alt="WattLord" />
        </div>
        <nav className={styles.links}>
          {links.map((item) => (
            <a key={item} href="#contact-us">
              {item}
            </a>
          ))}
        </nav>
      </div>
      <div className={styles.bottom}>
        <div className={styles.social}>
          <a
            href="https://t.me/wattlordhotels"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={telegram} alt="" />
          </a>
          <a
            href="https://twitter.com/WattLord"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={x} alt="" />
          </a>
          <a
            href="https://www.linkedin.com/company/80695426"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="" />
          </a>
          <a
            href="https://wattlord.medium.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={medium} alt="" />
          </a>
          <a
            href="https://www.facebook.com/wattlord"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebook} alt="" />
          </a>
          <a
            href="https://www.instagram.com/watt_lord/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="" />
          </a>
        </div>
        <span className={styles.copy}>{formatMessage({ id: "wlp.footer.copy" })}</span>
      </div>
    </footer>
  );
}

export { LandingFooter };
